<template>



</template>

<script>
export default {
    data() {
        return {
            archivos: [],
            archivo: {observaciones: ''}
        }
    },
    methods: {
        cambiar_estatus() {
            
        }
    }
}
</script>